<script lang="ts">
  import DrawerItems from "website_script/constants/DrawerItems"
  import callIcon from "../Icons/call.svg?raw"
  import messageIcon from "../Icons/message.svg?raw"
  import Icon from "../components/Icon.svelte"
  import { getContext } from "svelte"
  import type { Texts } from "website_script/types/texts"
  import type ModuleTypes from "website_script/constants/ModuleTypes"

  const texts = getContext<Texts>("texts")

  export let phoneNumber: string
  export let showMessageOption: boolean
  export let showCallOption: boolean
  export let handleClickOnItem: (
    item: DrawerItems,
    moduleType?: ModuleTypes
  ) => undefined
</script>

<div>
  <h4>{texts.contactPromptHeadline}</h4>
  <p>{texts.contactPromptText}</p>
  <div class="auws-options">
    {#if showCallOption}
      <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
      <div class="auws-option" on:click={handleClickOnItem(DrawerItems.CALL)}>
        <Icon
          size="40px"
          svgProps={{
            data: callIcon,
            alt: "call us",
          }}
        />
        <div class="auws-contact">
          {phoneNumber}
        </div>
      </div>
    {/if}
    {#if showMessageOption}
      <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
      <div
        class="auws-option"
        on:click={handleClickOnItem(DrawerItems.MESSAGE)}
      >
        <Icon
          size="40px"
          svgProps={{
            data: messageIcon,
            alt: "message us",
          }}
        />
        <div class="auws-contact">
          {texts.contactPromptMessage}
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  h4,
  p {
    color: #02234c;
    letter-spacing: 0.5px;
  }

  p {
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  h4 {
    margin-top: 5px;
    font-weight: 500;
    font-size: 18px;
  }

  .auws-option {
    background: #02234c;
    border-radius: 4px;
    color: white;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
  }

  .auws-option:first-child {
    margin-bottom: 8px;
  }

  .auws-contact {
    margin-right: 10px;
  }
</style>
